// Imports

import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { PageTabsList } from "src/modules/page-tabs/jsx/component.jsx";


// Stateful components

export class MyProgram extends React.Component{

    //
    // Lifecycle 
    //
    constructor(props) {
        super(props);

        this.state = {};

        // Binds
    }


    //
    // Render
    //

    render() {
        var this_component = this;
        var portal_context = this_component['context'];
        var current_page = portal_context['current_page'];
        
        return (
            <div className="my-program-tabs__wrapper">
                <PageTabsList current_page={current_page} extra_tabs='programs' />
            </div>
        );
    }

};

MyProgram.contextType = PortalContext;
